var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5c-4.963 0-9 4.037-9 9 0 2.17.776 4.163 2.063 5.719l.21.281h13.454l.21-.281A8.948 8.948 0 0 0 21 13.5c0-4.963-4.037-9-9-9ZM12 6c4.151 0 7.5 3.349 7.5 7.5 0 1.7-.595 3.243-1.547 4.5H6.047C5.095 16.743 4.5 15.2 4.5 13.5 4.5 9.349 7.849 6 12 6Zm0 .75a.751.751 0 0 0-.75.75c0 .413.337.75.75.75s.75-.337.75-.75a.751.751 0 0 0-.75-.75Zm-3 .797a.751.751 0 0 0-.75.75c0 .413.337.75.75.75s.75-.337.75-.75a.751.751 0 0 0-.75-.75Zm6 0a.751.751 0 0 0-.75.75c0 .413.337.75.75.75s.75-.337.75-.75a.751.751 0 0 0-.75-.75ZM6.797 9.75a.751.751 0 0 0-.75.75c0 .413.337.75.75.75s.75-.337.75-.75a.751.751 0 0 0-.75-.75Zm10.195.023-4.242 2.438A1.488 1.488 0 0 0 12 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 1.5-1.477V13.5l4.242-2.414-.75-1.313ZM6 12.75a.751.751 0 0 0-.75.75c0 .413.337.75.75.75s.75-.337.75-.75a.751.751 0 0 0-.75-.75Zm12 0a.751.751 0 0 0-.75.75c0 .413.337.75.75.75s.75-.337.75-.75a.751.751 0 0 0-.75-.75Zm-11.203 3a.751.751 0 0 0-.75.75c0 .413.337.75.75.75s.75-.337.75-.75a.751.751 0 0 0-.75-.75Zm10.406 0a.751.751 0 0 0-.75.75c0 .413.337.75.75.75s.75-.337.75-.75a.751.751 0 0 0-.75-.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.64fe82f0ca5b5b75336cffccb46d76b8.svg";
export { ForwardRef as ReactComponent };